<template>
  <div >
    <div class="homeText">
      <p>For decades now civilians in Kashmir have been victims mass violence at the hands of Indian security forces as well as from armed militants. From 1990 to 2011, the Jammu and Kashmir state government reportedly recorded a total of over 43,000 people killed. According to many human rights groups, this number goes above 110,000 for people who are missing or have been killed in the armed conflict.</p>
      <br>
      <p>Shocking as the government statistics are, human rights activists and lawyers say that the figure of civilian deaths caused by the security forces fails to reflect the true scale of violations by security forces. Over the past couple of decades, stories of these human right violations have been either erased from the records of various state departments or never correctly noted. The dearth of public information on many thousands of people who have lost their lives in Kashmir remains glaring.</p>
      <br>
      <p>A large part of these civilians killed have been at the hands of the Indian security forces. Officially who are supposed to be there as protectors against violence by armed rebel groups and an invasion from Pakistan, but their human rights violations against the populace has continued with impunity.
      This digital archive is an attempt to preserve public memory of lives lost in the most militarized region in the world. It is an attempt to place their stories at the center of the narrative. It is an attempt to preserve information in order to unearth the scale of human tragedy in the Kashmir Valley.</p>
    </div>
    <people  ></people>
  </div>
</template>

<script>
import People from "../People/People";
export default {
  components: {
    People
  }
};
</script>

<style lang="stylus" scoped>
.homeText {
  margin: 5rem 2rem;
  font-size: 1.5rem;
  font-family: 'Raleway', sans-serif;
}

@media only screen and (max-width: 600px) {
  .homeText {
    margin: 5rem 2rem 0 2rem;
    font-size: 1.2rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .homeText {
    margin: 5rem 3rem;
    font-size: 1.3rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .homeText {
    margin: 6rem 4rem;
    font-size: 1.3rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .homeText {
    margin: 7rem 7rem 0rem 7rem;
    font-size: 1.4rem;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .homeText {
    margin: 4.5rem 15rem 2.5rem 15rem;
    font-size: 1.3rem;
  }
}
</style>

